import { render, staticRenderFns } from "./KiraKiraPack03.vue?vue&type=template&id=7a6f243e&scoped=true&"
import script from "./KiraKiraPack03.vue?vue&type=script&lang=js&"
export * from "./KiraKiraPack03.vue?vue&type=script&lang=js&"
import style0 from "./KiraKiraPack03.vue?vue&type=style&index=0&id=7a6f243e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f243e",
  null
  
)

export default component.exports